import { BookBookmarkIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const BookmarkBook = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <BookBookmarkIcon size={Sizes[size]} {...rest} color={fill} />;
};

BookmarkBook.displayName = 'BookmarkBook';
